import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { LoginPage, ForgotPassword, RegistorUser } from "../CommonAPI/Common";
import {
  GetHeaderImg2,
  GetLogo,
  GetPanleName,
  GetHeaderImg1,
  Getfaviconimage,
  SubAdminPermission,
  AdminPermission,
} from "../CommonAPI/Admin";

import { FaEye, FaEyeSlash } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";

// Custom animated login success overlay (algo trading themed, fast, unique)
const LoginSuccessOverlay = ({ onFinish }) => {
  useEffect(() => {
    const timer = setTimeout(onFinish, 1100); // faster
    return () => clearTimeout(timer);
  }, [onFinish]);
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(18, 16, 16, 0.92)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        animation: "fadeIn 0.3s",
      }}
    >
      <style>{`
                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                @keyframes algoLine {
                    0% { stroke-dashoffset: 120; }
                    80% { stroke-dashoffset: 0; }
                    100% { stroke-dashoffset: 0; }
                }
                @keyframes algoDot {
                    0% { opacity: 0; }
                    60% { opacity: 0; }
                    80% { opacity: 1; }
                    100% { opacity: 1; }
                }
            `}</style>
      {/* Algo trading line chart animation */}
      <svg
        width="120"
        height="70"
        viewBox="0 0 120 70"
        style={{ marginBottom: 18 }}
      >
        <polyline
          points="10,60 30,40 50,50 70,20 90,35 110,10"
          fill="none"
          stroke="#1ccc8a"
          strokeWidth="4"
          strokeDasharray="120"
          strokeDashoffset="0"
          style={{
            filter: "drop-shadow(0 0 8px #1ccc8a)",
            animation: "algoLine 0.7s cubic-bezier(.7,0,.3,1) forwards",
          }}
        />
        {/* Dots at each point */}
        {[
          { x: 10, y: 60 },
          { x: 30, y: 40 },
          { x: 50, y: 50 },
          { x: 70, y: 20 },
          { x: 90, y: 35 },
          { x: 110, y: 10 },
        ].map((pt, i) => (
          <circle
            key={i}
            cx={pt.x}
            cy={pt.y}
            r="5"
            fill="#fff"
            stroke="#1ccc8a"
            strokeWidth="2"
            style={{
              opacity: 0,
              animation: `algoDot 0.9s ${0.1 + i * 0.08}s forwards`,
            }}
          />
        ))}
      </svg>
      <h2
        style={{
          color: "#1ccc8a",
          marginTop: 0,
          fontWeight: 700,
          letterSpacing: 1,
          fontSize: 28,
          textShadow: "0 2px 8px #111",
        }}
      >
        Login Successful!
      </h2>
      <p
        style={{
          color: "#fff",
          fontSize: 15,
          marginTop: 4,
          fontWeight: 500,
          letterSpacing: 0.5,
        }}
      >
        Welcome to Smart Trading
      </p>
    </div>
  );
};

const Login = ({  onNavigateToRegister}) => {
  const [Username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [changeType, setChangeType] = useState("password");
  const [visiablity, setVisiablity] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [forgotPassEmail, setForgotPassEmail] = useState("");
  const [forgotPassusername, setForgotPassusername] = useState("");
  const [userNameError, setUserNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [signinData, setSigninData] = useState({ username: "", password: "" });
  const [signupData, setSignupData] = useState({
    username: "",
    phone: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [signupShowPassword, setSignupShowPassword] = useState({
    password: false,
    confirmPassword: false,
  });
  const [signinShowPassword, setSigninShowPassword] = useState(false);
  const [showLoginSuccess, setShowLoginSuccess] = useState(false);
  const navigate = useNavigate();
  const handleLogin = async (usernameArg, passwordArg) => {
    const user = usernameArg !== undefined ? usernameArg : Username;
    const pass = passwordArg !== undefined ? passwordArg : password;
    const data = { Username: user, password: pass };
    await LoginPage(data)
      .then((response) => {
        if (response.Status) {
          toast.success("Login Successful!", {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          if (response.Role === "Subadmin") {
            getSubAdminPermission();
          } else if (response.Role === "Admin") {
            getAdminPermisson();
          }
          localStorage.setItem("Role", response.Role);
          localStorage.setItem("name", user);
          localStorage.setItem("token", response.access_token);
          setShowLoginSuccess(true); // Show animated overlay
          // Navigate instantly after animation overlay ends
          setTimeout(() => {
            setShowLoginSuccess(false);
            if (response.Role === "Admin") {
              navigate("/admin/dashboard");
            } else if (response.Role === "User") {
              navigate("/user/dashboard");
            } else if (response.Role === "Superadmin") {
              navigate("/superadmin/dashboard");
            } else if (response.Role === "Subadmin") {
              navigate("/subadmin/dashboard");
            }
          }, 1100); // match overlay duration
        } else {
          Swal.fire({
            backdrop: "#121010ba",
            confirmButtonColor: "#1ccc8a",
            title: "Error!",
            text: response.message,
            icon: "error",
            timer: 1500,
            timerProgressBar: true,
          });
        }
      })
      .catch((err) => {
        console.log("Error in user login", err);
      });
  };

  const getSubAdminPermission = async () => {
    const req = { username: Username };
    await SubAdminPermission(req)
      .then((response) => {
        if (response.Status) {
          localStorage.setItem(
            "SubAdminPermission",
            JSON.stringify(response.Data)
          );
        }
      })
      .catch((err) => {
        console.log("Error in fetching the permission", err);
      });
  };

  const getAdminPermisson = async () => {
    const req = { username: Username };
    await AdminPermission(req)
      .then((response) => {
        if (response.Status) {
          localStorage.setItem(
            "AdminPermission",
            JSON.stringify(response.Data)
          );
        }
      })
      .catch((err) => {
        console.log("Error in fetching the permission", err);
      });
  };

  const [rightPanelActive, setRightPanelActive] = useState(false);

  const handleForgotPass = async () => {
    if (!emailError && !userNameError) {
      const data = { Email: forgotPassEmail, username: forgotPassusername };

      await ForgotPassword(data)
        .then((response) => {
          if (response.Status) {
            Swal.fire({
              // background: "#1a1e23 ",
              backdrop: "#121010ba",
              confirmButtonColor: "#1ccc8a",
              title: "Success",
              text: response.Data,
              icon: "success",
              timer: 1500,
              timerProgressBar: true,
            });
            setShowModal(false);
          } else {
            Swal.fire({
              // background: "#1a1e23 ",
              backdrop: "#121010ba",
              confirmButtonColor: "#1ccc8a",
              title: "Error",
              text: response.Data,
              icon: "error",
              timer: 1500,
              timerProgressBar: true,
            });
          }
        })
        .catch((err) => {
          console.log("Error in sending the mail", err);
        });
    }
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleEmailChange = (e) => {
    const email = e.target.value;
    setForgotPassEmail(email);
    if (!email) {
      setEmailError("Email cannot be empty");
    } else if (!validateEmail(email)) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");
    }
  };

  const handleUsernameChange = (e) => {
    const username = e.target.value;
    setForgotPassusername(username);
    if (!username) {
      setUserNameError("Email cannot be empty");
    } else {
      setUserNameError("");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  const GetLogoimage = async () => {
    await GetLogo()
      .then((response) => {
        if (response.status) {
          document.getElementById("imglogo").src =
            "data:image/png;base64," + response.image_data;
          localStorage.setItem(
            "logo",
            "data:image/png;base64," + response.image_data
          );
        } else {
        }
      })
      .catch((err) => {
        console.log("Error Group data fetch error", err);
      });
  };

  const get_header_img1 = async () => {
    await GetHeaderImg1()
      .then((response) => {
        if (response.status) {
          localStorage.setItem(
            "header_img1",
            "data:image/png;base64," + response.image_data
          );
        } else {
        }
      })
      .catch((err) => {
        console.log("Error Group data fetch error", err);
      });
  };

  const get_header_img2 = async () => {
    await GetHeaderImg2()
      .then((response) => {
        if (response.status) {
          localStorage.setItem(
            "header_img2",
            "data:image/png;base64," + response.image_data
          );
        } else {
        }
      })
      .catch((err) => {
        console.log("Error Group data fetch error", err);
      });
  };

  const Getfaviconimg = async () => {
    await Getfaviconimage()
      .then((response) => {
        if (response.status) {
          document.getElementsByClassName("set_favicon")[0].href =
            "data:image/png;base64," + response.image_data;
          localStorage.setItem(
            "fevicon",
            "data:image/png;base64," + response.image_data
          );
        } else {
        }
      })
      .catch((err) => {
        console.log("Error Group data fetch error", err);
      });
  };

  const GetPanel_Name = async () => {
    await GetPanleName()
      .then((response) => {
        if (response.Status) {
          document.getElementsByClassName("title_name")[0].innerText =
            response.CompanyName;
          localStorage.setItem("pannel_name", response.CompanyName);
        } else {
        }
      })
      .catch((err) => {
        console.log("Error Group data fetch error", err);
      });
  };

  useEffect(() => {
    get_header_img2();
    get_header_img1();
    Getfaviconimg();
    GetPanel_Name();
    GetLogoimage();
  }, []);

  const signinHandler = (e) => {
    e.preventDefault();
    // Always get the latest values from the DOM in case of autofill
    const username =
      document.querySelector(
        '.newlogin-sign-in-container input[name="username"]'
      )?.value || signinData.username;
    const password =
      document.querySelector(
        '.newlogin-sign-in-container input[name="password"]'
      )?.value || signinData.password;
    if (username && password) {
      // Pass directly to handleLogin, do not rely on setState (which is async)
      handleLogin(username, password);
    } else {
      Swal.fire({
        backdrop: "#121010ba",
        confirmButtonColor: "#1ccc8a",
        title: "Error!",
        text: "Please fill all the fields",
        icon: "error",
        timer: 1500,
        timerProgressBar: true,
      });
    }
  };

  const handleRegistor = async (e) => {
    if (e) e.preventDefault();
    // Phone number validation: must be exactly 10 digits
    if (!/^\d{10}$/.test(signupData.phone)) {
      Swal.fire({
        backdrop: "#121010ba",
        confirmButtonColor: "#1ccc8a",
        title: "Error!",
        text: "Phone number must be exactly 10 digits!",
        icon: "error",
        timer: 1500,
        timerProgressBar: true,
      });
      return;
    }
    if (signupData.password !== signupData.confirmPassword) {
      Swal.fire({
        backdrop: "#121010ba",
        confirmButtonColor: "#1ccc8a",
        title: "Error!",
        text: "Password and Confirm Password must be the same!",
        icon: "error",
        timer: 1500,
        timerProgressBar: true,
      });
      return;
    }
    const data = {
      SignuserName: signupData.username,
      mobile_no: signupData.phone,
      SignEmail: signupData.email,
      Signpassword: signupData.password,
      ConfirmPassword: signupData.confirmPassword,
    };

    await RegistorUser(data)
      .then((response) => {
        if (response.Status) {
          toast.success(response.message, {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
            onClose: () => setRightPanelActive(false),
          });
        } else {
          return Swal.fire({
            backdrop: "#121010ba",
            confirmButtonColor: "#1ccc8a",
            title: "Error!",
            text: response.message,
            icon: "error",
            timer: 1500,
            timerProgressBar: true,
          });
        }
      })
      .catch((err) => {
        console.log("Error in adding the new user", err);
      });
  };

return (
    <section className="premium-auth-page">
      {/* --- Animated Background Elements --- */}
      <div className="animated-bg-elements">
        {/* These div elements are styled and animated by the CSS below */}
        <div className="bg-bar bar-1"></div>
        <div className="bg-bar bar-2"></div>
        <div className="bg-bar bar-3"></div>
        <div className="bg-bar bar-4"></div>
        <div className="bg-bar bar-5"></div>
        <div className="bg-bar bar-6"></div>
        <div className="bg-bar bar-7"></div>
      </div>
      {/* --- END Animated Background Elements --- */}

      <div className="premium-auth-container">
        
        {/* Logo Section */}
        <div className="premium-logo-header">
         <img
            className=""
            alt="logo"
            id="imglogo"
            style={{
              width: "150px", // Fixed smaller width
              height: "auto", // Maintain aspect ratio
              objectFit: "contain", // Don't crop the logo
            }}
          />
        </div>

        {/* Form Card (Frosted Glass Effect) */}
        <div className="premium-form-card"> 
          <h1 className="premium-title">Access Your Trading Terminal.</h1>
          <p className="premium-subtitle">Enter your credentials to view real-time markets.</p>
          
          <form className="premium-form" autoComplete="on" onSubmit={signinHandler}>
            
            <input
              type="text"
              name="username"
              autoComplete="username"
              placeholder="Username"
              className="premium-input"
              value={signinData.username}
              onChange={(e) => setSigninData({ ...signinData, username: e.target.value })}
            />
            
            <div className="premium-input-wrapper">
              <input
                type={signinShowPassword ? "text" : "password"}
                name="password"
                autoComplete="current-password"
                placeholder="Password"
                className="premium-input"
                value={signinData.password}
                onChange={(e) => setSigninData({ ...signinData, password: e.target.value })}
              />
              <span className="premium-password-toggle" onClick={() => setSigninShowPassword((v) => !v)}>
                {signinShowPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            
            <div className="premium-options-row">
                <a 
                    href="#" 
                    className="premium-forgot-link" 
                    onClick={(e) => { e.preventDefault(); setShowModal(true); }}
                >
                    Forgot Password?
                </a>
            </div>

            <button type="submit" className="premium-button primary-action-btn">
                Sign In
            </button>
          </form>

          <p className="premium-switch-text">
            Ready to trade? 
          
            <Link to="/register"  className="premium-switch-link">  Open a Free Account</Link>
          </p>
        </div>
      </div>

      {showModal && (
        <div
          className="modal custom-modal d-flex"
          id="add_vendor"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered modal-md">
            <div className="modal-content forgett">
              <div className="modal-header border-0 pb-0">
                <div className="form-header modal-header-title text-start mb-0">
                  <h4 className="mb-0 premium-title">Forgot Password</h4>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setShowModal(!showModal)}
                />
              </div>
              <div>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-lg-12 col-sm-12">
                      <div className="input-block mb-3">
                        {/* <label>Email</label> */}
                        <input
                          type="text"
                          className="premium-input"
                          placeholder="Enter Email"
                          onChange={handleEmailChange}
                          value={forgotPassEmail}
                        />
                        {emailError && (
                          <div
                            className="error-message"
                            style={{ color: "red" }}
                          >
                            {emailError}
                          </div>
                        )}
                      </div>
                    </div>
                    {/* <div className="col-lg-12 col-sm-12">
                                            <div className="input-block mb-3">
                                                <label>Username</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Username"
                                                    onChange={handleUsernameChange}
                                                    value={forgotPassusername}
                                                />
                                                {userNameError && (
                                                    <div className="error-message" style={{ color: 'red' }}>
                                                        {userNameError}
                                                    </div>
                                                )}
                                            </div>
                                        </div> */}
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="submit"
                    data-bs-dismiss="modal"
                    className=" premium-button primary-action-btn "
                    onClick={handleForgotPass}
                  >
                    Send
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      
      
      {showLoginSuccess && (
        <LoginSuccessOverlay onFinish={() => setShowLoginSuccess(false)} />
      )}
      <ToastContainer />
    </section>
);
};

export default Login;
